import React from "react";
import { Dialog, Result, Button, ButtonType } from "@yy/tofu-ui-react";
import { closeModal, ModalRoutes } from "./ModalSwitch";
import { useHistory, useLocation } from "react-router-dom";
import qs from "qs";
import { thousandSeparator } from "../../lib/util";
import { stat } from "../../lib/hooks/useHiidoPV";

const PaySuccessModal = () => {
  const history = useHistory();
  const location = useLocation();
  const { balance, paymentAmount } = qs.parse(location.search, { ignoreQueryPrefix: true });

  return (
    <Dialog
      active
      title=""
      className="pay-success-dialog"
      showConfirmBtn={false}
      showCancelBtn={false}
      wrapperStyle={{ width: 562 }}
      onCancel={closeModal(history)}
    >
      <Result
        status="success"
        title="支付成功"
        subTitle={
          <>
            <span>成功缴纳保证金金额：￥{thousandSeparator(paymentAmount as string)}</span>
            <br />
            <span>YY保证金账户可用余额：￥{thousandSeparator(balance as string)}</span>
          </>
        }
      >
        <div className="btns">
          <Button
            type={ButtonType.Emphasis}
            onClick={() => {
              // 数据上报
              stat.emit({ eventid: 20030927, act_type: "209" });
              // 直接升级星级流程
              history.push({
                pathname: ModalRoutes.BeStarGuildProcess,
                search: qs.stringify({ auto: 1 }, { addQueryPrefix: true }),
              });
            }}
          >
            确定升级
          </Button>
          <Button type={ButtonType.Cancel} onClick={closeModal(history)}>
            取消
          </Button>
        </div>
      </Result>
    </Dialog>
  );
};

export default PaySuccessModal;
